import api from '@/assets/js/api';
import { Utils } from '@/assets/js/utils';
import store from '../../store';

export const MixinAllowedMenu = {
    data() {
        return {
            allowedMenuEvent: null,
        };
    },

    beforeMount() {
        this.allowedMenuEvent = new AllowedMenuEvent();
        this.initMixin();
    },

    methods: {
        async initMixin() {
            const user = store.state.auth.user;
            if (parseInt(user.centerId, 10) !== 0) {
                await this.allowedMenuEvent.init();
            }
        },
        isAllowedMenu(menu) {
            if (this.allowedMenuEvent === null) {
                return false;
            }

            return this.allowedMenuEvent.isAllowedMenu(menu);
        },
        isAllowed(menu, eventNum = '') {
            if (this.allowedMenuEvent === null) {
                return false;
            }

            /*
			if(!this.allowedMenuEvent.isAllowedMenu(menu)) {
				return false;
			}
			 */

            const menuEventCd = `${menu}_EVENT_${eventNum
                .toString()
                .padStart(3, '0')}`;
            return this.allowedMenuEvent.isAllowed(menuEventCd);
        },
        goMainIfNotAllowed(menu, eventNum) {
            if (!this.isAllowed(menu, eventNum)) {
                this.$router.push({ path: '/madmin/center/main' });
            }
        },
        checkAllowedClick(menu, eventNum, successCallback) {
            if (!this.isAllowed(menu, eventNum)) {
                alert('사용권한이 없습니다. 대표관리자에게 권한을 요청하세요.');
                return false;
            } else if (!Utils.isEmpty(successCallback)) {
                successCallback();
            }
            return true;
        },
        checkAllowed(menu, eventNum) {
            return this.isAllowed(menu, eventNum);
        },
    },
};

export class AllowedMenuEvent {
    menuAuthKeyValues = {
        m_board_yn: 'BD', // 업무게시판
        m_cust_yn: 'MB', // 회원
        m_history_yn: 'HS', // 히스토리
        m_lesson_yn: 'LE', // 수업
        m_pay_yn: 'PA', // 급여
        m_resv_yn: 'CSAPP', // 회원예약 APP
        m_sale_yn: 'SA', // 매출
        m_schd_yn: 'SC', // 스케줄
        m_stat_yn: 'ST', // 통계
        m_touch_yn: 'TC', // 터치출석
    };

    eventCds = null;
    validMenus = null;

    async init() {
        if (this.eventCds === null) {
            try {
                this.eventCds = (await this.getEventCd()).data;
                localStorage.setItem(
                    'menuEventCds',
                    JSON.stringify(this.eventCds)
                );
                // 마스킹 필터가 반응형으로 다시 그려지도록 store 에도 반영한다
                store.commit('auth/setMenuEventCds', this.eventCds);

                // @TODO: 계약이 없는 센터의 경우 처리할지 여부 확인 후 오픈

                const ftContractProduct = (
                    await this.getCenterValidFtContractProduct()
                ).data;
                this.validMenus = [];
                for (const key in this.menuAuthKeyValues) {
                    if (ftContractProduct[key]) {
                        this.validMenus.push(this.menuAuthKeyValues[key]);
                    }
                }
                localStorage.setItem(
                    'validMenus',
                    JSON.stringify(this.validMenus)
                );
            } catch (error) {
                console.log(error);
            }
        }
    }

    getEventCd() {
        // 스웨거 검색: 센터직원권한 > 센터 특정권한에게 허가된 이벤트코드 조회
        return api.get('/admin/api/centerStaffRole/staff/allowed/event/all/' + store.state.auth.user.roleId);
    }

    getCenterValidFtContractProduct() {
        // 센터가 현재 계약중인 유효한 계약을 가져온다
        return api.get('/admin/api/center/ftcontract/valid');
    }

    isAllowedMenu(menu) {
        // @TODO: 테스트를 위해 메뉴 권한 설정은 막아둠
        // 통합테스트 시 오픈
        // return true;
        // /////////////

        if (this.validMenus === null) {
            this.validMenus = JSON.parse(localStorage.getItem('validMenus'));
        }

        if (this.validMenus !== null) {
            for (const cd of this.validMenus) {
                if (cd === menu) {
                    return true;
                }
            }
        }

        return false;
    }

    isAllowed(menuEventCd) {
        if (this.eventCds === null) {
            this.eventCds = JSON.parse(localStorage.getItem('menuEventCds'));
        }

        if (this.eventCds !== null) {
            for (const cd of this.eventCds) {
                if (cd === menuEventCd) {
                    return true;
                }
            }
        }

        return false;
    }
}
